import { getFormattedMatch } from '../../../components/AlphaTestingStatus/TestingStatus/SummaryCheckData';
import { addModifiers } from '../../../shared/helpers';
import { formatHTMLMessageHelper } from '../../../shared/helpers/internationalization';
import * as React from 'react';
import { Theme } from '../../../shared/api/api';

import './DataTableCommon.scss';
import { Popup } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

interface ThemeLabelProps {
  themes: Theme[];
}
export const ThemeLabel = ({ themes }: ThemeLabelProps) => {
  const intl = useIntl();
  if (!themes || !themes.length) {
    return <> </>;
  }
  const formattedMatches = themes.map(theme => getFormattedMatch(theme));

  return (
    <Popup
      trigger={
        <div className="data-explorer-theme-label">
          <div className={addModifiers('data-explorer-theme-label-button', ['theme'])}>
            <div className={addModifiers('data-explorer-theme-label-button-icon', ['theme'])} />
            <div className={'summary__status-theme-text'}> {themes.map(theme => 'x' + theme.multiplier).join(', ')}</div>
          </div>
        </div>
      }
      content={formattedMatches.map(formattedMatch => (
        <div className="data-explorer-theme-label__tooltip-item" key={formattedMatch.id}>
          {formatHTMLMessageHelper(intl, 'statusMessageIS.MATCHES_THEMES.PASS.single', formattedMatch)}
        </div>
      ))}
      basic={true}
      //position="right center"
    />
  );
};
